<template>
  <!-- modal 샘플 color: blue(#4AC0FF) / red(#FF4A4A) -->
  <!-- <ModalConfirm :dialog="false" :str="'기존 가이드로 자동배치됩니다.<br>변경하시겠어요?'" :btn1="{str:'취소',event: 'close'}" :btn2="{str:'삭제하기',event: 'delete', color:'#FF4A4A'}" @close="이벤트명" @delete="이벤트명"/> -->
    <v-dialog
      :value="dialog"
      width="310"
      :persistent="true"
      :no-click-animation="true"
      :overlay-opacity="0.7"
      content-class="dialog"
    >
      <v-card>
        <v-card-text class="dialog-content">
          <div v-html="str"></div>
        </v-card-text>
        <v-card-actions class="pa-0">
          <v-btn
            plain
            :ripple="false"
            height="56"
            :color="`${btn1.color}`"
            class="fs-16 fw-500 border-r"
            @click="$emit(`${btn1.event}`)"
          >
            {{btn1.str}}
          </v-btn>
          <v-btn
            plain
            :ripple="false"
            height="59"
            :color="`${btn2.color}`"
            class="fs-16 fw-500"
            @click="$emit(`${btn2.event}`)"
          >
            {{btn2.str}}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-btn v-if="isClose" icon plain :ripple="false" class="btn-close" @click="$emit('confirmClose')">
        <Close/>
      </v-btn>
    </v-dialog>
</template>
<script>
import Close from "@/components/icons/Close";
export default {
    props:{
          dialog: {
              type: Boolean,
              default: false,
          },
          str: {
              type: String,
              default: '',
          },
          btn1:{
              type: Object,
              default: () => ({}),
          },
          btn2:{
              type: Object,
              default: () => ({}),
          },
          isClose:{
              type: Boolean,
              default: false,
          }
    },
  data: () => ({
  }),
  components: {
    Close,
  },
  methods:{
  },
  mounted () {
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-dialog{
  position: relative;
  .v-card__actions{
    .v-btn{
      flex:1;
      border-radius: 0;
    }
  }
  .border-r{
    border-right: 1px solid #E6E8EA;
  }
}
.btn-close{
  position: absolute;
  right: 8px;
  top: 8px;
  z-index: 2;
  width: 28px;
  height: 28px;
}
</style>
